import Enum from 'cg-enum'

export const courseEnum = new Enum(
  ['threeLesson', 'literacy', 'liveThematic', 'liveLongTerm'],
  -26
)
export const courseTypeName = {
  // [courseEnum.free]: 'free',
  // [courseEnum.thematic]: 'thematic',
  // [courseEnum.longTerm]: 'longTerm',
  [courseEnum.liveLongTerm]: 'liveLongTerm', // 同步课
  [courseEnum.liveThematic]: 'liveThematic', // 专题课
  [courseEnum.literacy]: 'Literacy', // 素养课程
  [courseEnum.threeLesson]: 'threeLesson' // 三节课
}



// WEBPACK FOOTER //
// ./src/defines/course.js